import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DateField } from "@/components/ui/date-field";
import { toast } from "sonner";
import { CalendarClock } from "lucide-react";

export function PostponeTaskDialog({ task, onClose, onDone }) {
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");
  const [reasons, setReasons] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/task-postpone-reasons").then((r) => setReasons(r.data.reasons || [])).catch(() => {}); }, []);

  const save = async () => {
    if (!date) { toast.error("Kies een nieuwe datum"); return; }
    if (!reason.trim()) { toast.error("Geef een korte reden op"); return; }
    setBusy(true);
    try { await api.patch(`/tasks/${task.id}`, { followup_date: date, postpone_reason: reason.trim() }); toast.success("Taak uitgesteld"); onDone(); }
    catch { toast.error("Uitstellen mislukt"); }
    finally { setBusy(false); }
  };

  const suggestions = reasons.filter((r) => r.toLowerCase().includes(reason.toLowerCase()) && r !== reason).slice(0, 6);

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="postpone-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><CalendarClock className="h-5 w-5 text-amber-600" /> Taak uitstellen</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="text-sm text-slate-500">{task.tenant_name || task.client_name || "—"}: {task.outcome}</div>
          <div><Label>Nieuwe opvolgdatum</Label><DateField value={date} onChange={setDate} min={new Date().toISOString().slice(0, 10)} testId="postpone-date" /></div>
          <div>
            <Label>Reden (kort)</Label>
            <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Kies of typ een reden" data-testid="postpone-reason-input" />
            {suggestions.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mt-2" data-testid="postpone-reason-suggestions">
                {suggestions.map((r) => (
                  <button key={r} type="button" onClick={() => setReason(r)} className="px-2.5 py-1 rounded-full text-xs border bg-white text-slate-600 hover:border-amber-400 hover:text-amber-700 transition-colors" data-testid="postpone-reason-chip">{r}</button>
                ))}
              </div>
            )}
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose} data-testid="postpone-cancel">Annuleren</Button>
            <Button className="bg-amber-600 hover:bg-amber-700" disabled={busy} onClick={save} data-testid="postpone-save">Uitstellen</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
